import type { InvoiceDto } from '../../dtos/invoice-list.dto';
import type { BaseDataTableUrlParamsModel } from '../base/base-data-table-url-params.model';
import type { TransactionDto } from '../../dtos/transactions/transaction-dto';

export enum ReportType {
  CSV = 'csv',
  EXCEL = 'xlsx',
  PDF = 'pdf',
}

export interface ExportBaseReportParams {
  url: string;
  type: ReportType;
  filename: string;
  successMessage: string;
  errorMessage: string;
}

export interface ExportReportParams extends ExportBaseReportParams {
  options?: BaseDataTableUrlParamsModel<InvoiceDto>;
}

export interface ExportTransactionsReportParams extends ExportBaseReportParams {
  options?: BaseDataTableUrlParamsModel<TransactionDto>;
}
